import { isAbbyyFlow } from "../helpers/constants";
import { PAYMENT_STATUS_COMPLETED } from "../../constants";

export const STATUSID = {
  FAILED: 4,
  SUCCESS: 5,
  RETAKE: 8,
  REFRESH: 0,
};

export const LOADING_TIMER = 30000;

export const failureStatus = [
  "XLF",
  "XSF",
  "EXF",
  "XBT",
  "XID",
  "XAD",
  "XMS",
  "XMF",
  "XMV",
  "XUE",
  "IPF",
];
export const aidStatuses = ["PEN", "RTS", "RTD", "CNT", "EXS", "SUC", "RSC"];
export const iproovStatuses = ["IPN", "IPR", "IPC", "SUC"];

export const LOADING_MESSAGES = [
  {
    key: "screen-modal-presence-verification-uploadYourDocuments",
    value: "Uploading images",
  },
  {
    key: "screen-modal-presence-verification-verifyingYourDocuments",
    value: "Verifying images",
  },
  {
    key: "screen-modal-presence-verification-processingYourDocuments",
    value: "Processing images",
  },
];

export const STATUS_TEXT = {
  [STATUSID.FAILED]: {
    key: "screen-modal-presence-verification-selfie-failed-message",
    value:
      "The system couldn't verify your photo(s). Please visit a DMV office to finalize your REAL ID Application.",
  },
  [STATUSID.SUCCESS]: {
    key: "screen-modal-presence-verification-selfie-success-message",
    value:
      "Identity verified.\nSelect 'Next' to continue and finalize your application.",
  },
  [STATUSID.RETAKE]: {
    key: "screen-modal-presence-verification-selfie-retake-message",
    value: "There was a problem verifying your photo(s).",
  },
};

export const BUTTON_TEXT = {
  [STATUSID.FAILED]: {
    key: "screen-modal-presence-verification-next",
    value: "Next",
  },
  [STATUSID.SUCCESS]: {
    key: "screen-modal-presence-verification-next",
    value: "Next",
  },
  [STATUSID.RETAKE]: {
    key: "screen-modal-presence-verification-reTake",
    value: "Retry",
  },
  [STATUSID.REFRESH]: {
    key: "screen-modal-presence-verification-reTake",
    value: "Retry",
  },
};

export const OPT_IN_OUT_MESSAGE = {
  message1: {
    key: "screen-modal-presence-verification-eligible-to-complete",
    value: "You may be eligible to complete your REAL ID application online.",
  },
  message2: {
    key: "screen-modal-presence-verification-select-optin-to-continue",
    value:
      "Select 'Yes' to receive your REAL ID without visiting a DMV office. You must verify your identity by taking two photos of yourself.",
  },
  message3: {
    key: "screen-modal-presence-verification-select-optout-for-appointment",
    value:
      "OR select 'No' and finalize your application at your local DMV office.",
  },
};

// const failedEligibleForExtendedVerification = (application) => application.eligibleForExtendedVerification
const successMTS = (documentUpload) =>
  failureStatus.includes(documentUpload?.MTS) || documentUpload?.MTS === "SUC";
export const pendingRetakePV = (documentUpload) =>
  ["PEN", "RSC"].includes(documentUpload?.MTS);
export const iproovPendingRetakePV = (documentUpload) =>
  ["IPN", "IPR"].includes(documentUpload?.MTS);

const checkDocStatus = (document) => {
  const allDocs = [];
  if (["PEN", "INP", "DNQ", "SUC"].includes(document?.ATD)) {
    allDocs.push(document.statusId);
  } else if (
    failureStatus.includes(document?.ATD) &&
    document?.statusId === 4
  ) {
    allDocs.push(0);
  } else {
    allDocs.push(document.statusId);
  }
  return allDocs;
};

export const isFailureStatus = (status) => {
  return failureStatus.includes(status);
};

export const isQualifiedStatus = (status) => {
  return status !== "DNQ";
};

export const isSuccessStatus = (status) => {
  return ["CNT", "EXS", "IPC", "SUC"].includes(status);
};

export const isRetryStatus = (status) => {
  return ["RTD", "RTS", "IPR", "RSC"].includes(status);
};

export const isPendingStatus = (status) => {
  return ["PEN", "IPN"].includes(status);
};

export const isPendingConfirmationStatus = (status) => {
  return status === "PUC";
};

const checkFinalConfirmationFlow = (application, documentUploads) => {
  let allDocs = [];
  let rawDocs = [];
  let docsVerifiedNum;
  if (!application?.hasOwnProperty("documents") && documentUploads?.[6]) {
    const documentsArray = documentUploads[6];
    if (
      ["SUC", "EXF"].includes(documentsArray[0].MTS) &&
      ["SUC", "EXF"].includes(documentsArray[0].MTS)
    ) {
      return true;
    }
    return false;
  }
  if (documentUploads?.[8]) {
    [...documentUploads?.[8]].map(
      (doc) => (allDocs = allDocs.concat(checkDocStatus(doc)))
    );
    rawDocs = [...documentUploads?.[8]];
  }
  if (documentUploads?.[7]) {
    [...documentUploads?.[7]].map(
      (doc) => (allDocs = allDocs.concat(checkDocStatus(doc)))
    );
    rawDocs = [...rawDocs, ...documentUploads?.[7]];
  }
  if (rawDocs.length > 0) {
    const checkEXF = rawDocs.filter(
      (doc) =>
        (isAbbyyFlow(doc.ATD) && doc.statusId > 1 && doc.statusId !== 4) ||
        (isFailureStatus(doc.ATD) && doc.allowAbbyy === false)
    );
    if (checkEXF.length) {
      docsVerifiedNum = checkEXF.length;
    } else {
      docsVerifiedNum = allDocs.reduce(
        (counter, docStatus) => (docStatus === 5 ? counter + 1 : counter),
        0
      );
    }
    return docsVerifiedNum === allDocs.length;
  }
  return false;
};

// Returns true only if pvDependency is a positive number.
// Handles null, undefined, zero, negative, and non-numeric values.
function hasPositivePvDependency(value) {
  return Number(value) > 0;
}

/**
 * generateUrl
 * -----------
 * Determines the next UI route in the identity‑verification flow based on:
 *   • the application record
 *   • the current state of all document uploads
 *   • optional success flags passed in by the caller
 *
 * This function encodes the business rules for navigating between:
 *   1. Document Upload
 *   2. Presence Verification
 *   3. Final Confirmation
 *
 * WHY THIS EXISTS:
 * ----------------
 * This method centralizes all branching logic so the UI does not
 * scatter navigation rules across multiple components.
 *
 * KEY CONCEPTS:
 * -------------
 * pvDependency:
 *   - If present, the application *requires* Presence Verification after document is
 *     uploaded.
 *   - The value of `pvDependency` is the categoryId of the document that
 *     represents the PV requirement.
 *
 * documentUploads:
 *   - A map of categoryId → array of uploaded documents.
 *
 * successStatus:
 *   - Optional override used when a flow has just completed successfully and
 *     the caller wants to force navigation to the Presence Verification step.
 *
 * HIGH‑LEVEL FLOW:
 * ----------------
 * 1. If the application has a PV dependency:
 *      a. Document Upload must be completed before PV.
 *      b. If the PV-dependent document needs reupload or is pending →
 *           Stay on Document Upload.
 *      c. If successStatus is true → go directly to Presence Verification.
 *      d. If identity document is completed AND final confirmation is allowed →
 *           go to Final Confirmation.
 *
 * 2. If the application does NOT have a PV dependency:
 *      a. Presence Verification is performed first
 *      b. If PV retake is required → stay on Presence Verification.
 *      c. Document Upload is performed after PV
 *      d. If successStatus is true OR final confirmation is allowed →
 *           go to Final Confirmation.
 *
 * 3. If none of the above conditions match:
 *      → remain on current page
 *
 * RETURN VALUE:
 * -------------
 * A string route:
 *   "/document-upload"
 *   "/presence-verification"
 *   "/final-confirmation"
 *
 * Or null if no navigation should occur.
 */
export const generateUrl = (
  application,
  documentUploads,
  { successStatus = false } = {}
) => {
  const pvCategoryId = application?.pvDependency;
  const hasPvDependency = hasPositivePvDependency(pvCategoryId);

  const pvUpload = documentUploads[6]?.[0];
  if (application?.skipDMV === false) {
    if (checkFinalConfirmationFlow(application, documentUploads)) {
      return "/final-confirmation";
    }
    return "/document-upload";
  }
  if (hasPvDependency) {
    const dependentUpload = documentUploads?.[pvCategoryId]?.[0];

    if (successStatus) {
      return "/presence-verification";
    }

    const identityStatusId = pvUpload?.statusId;
    const pvDependentStatusId = dependentUpload?.statusId;

    const pvCompleted = identityStatusId === 5;

    if (
      pvCompleted &&
      checkFinalConfirmationFlow(application, documentUploads)
    ) {
      return "/final-confirmation";
    }

    const needsReuploadOrPending = [1, 4].includes(pvDependentStatusId);

    if (needsReuploadOrPending && !successStatus) {
      return "/document-upload";
    }
  } else {
    if (successMTS(pvUpload)) {
      return "/document-upload";
    }

    if (pendingRetakePV(pvUpload) || iproovPendingRetakePV(pvUpload)) {
      return "/presence-verification";
    }

    if (
      successStatus ||
      checkFinalConfirmationFlow(application, documentUploads)
    ) {
      return "/final-confirmation";
    }
  }
  return null;
};

// Same rule as the landing page "Pay Now" button: only skipDMV applications pay
export const isNchRncPaymentRequired = (application) =>
  application?.skipDMV === true &&
  application?.feeAmount > 0 &&
  application?.status?.PAYMENT?.toUpperCase() !== PAYMENT_STATUS_COMPLETED;

const NCH_RNC_STEPS = [
  "/landing",
  "/presence-verification",
  "/document-upload",
  "/final-confirmation",
];

// A page is allowed unless it is a later step than the user's current step.
export const isNchRncPageAllowed = (page, step) =>
  NCH_RNC_STEPS.indexOf(page === "/" ? "/document-upload" : page) <=
  NCH_RNC_STEPS.indexOf(step);

export const generateErrorUrl = (error, businessProgram) => {
  const url = `/${businessProgram}`;

  if (error.name === "MaintenanceEnabled") {
    return `${url}/under-maintenance`;
  }
  // Expired token
  if (error.response?.status === 401 || error.response?.status === 422) {
    return `${url}/expired`;
  }
  // Bad token
  if (error.response?.status === 404) {
    return `${url}/error`;
  }
};

export const getCaptureType = (documentUpload) => {
  const mtsStatus = documentUpload?.MTS;
  if (aidStatuses.includes(mtsStatus)) {
    return "AID";
  }
  if (iproovStatuses.includes(mtsStatus)) {
    return "IPROOV";
  }
  return "ABBYY";
};

export const isAIDCapture = (status) => {
  if (!status) {
    throw new Error(
      "Status is undefined. Check that the document's ATD status is passed as an argument."
    );
  }

  return (
    isPendingStatus(status) ||
    isRetryStatus(status) ||
    isPendingConfirmationStatus(status)
  );
};
